{
  "search": "Søk",
  "searchWithin": "Søk i"
}
